import { render, staticRenderFns } from "./AiPhraseDialog.vue?vue&type=template&id=28dc17e4&scoped=true&"
import script from "./AiPhraseDialog.vue?vue&type=script&lang=ts&"
export * from "./AiPhraseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AiPhraseDialog.vue?vue&type=style&index=0&id=28dc17e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc17e4",
  null
  
)

export default component.exports